module.exports = __webpack_public_path__ + "media/bootstrap-icons/laptop-fill-bdae6e06.svg";